import { writable } from 'svelte/store';

const __ = writable((expression) => expression);

export default __;
